/**
 * This file serves as a central entry point for API calls
 * Exports the enhanced API implementation that handles URL transformations
 */

// Import the improved API
import * as api from './api';

console.log(`API: Using enhanced API implementation with URL transformation`);

// Export the API implementation
export default api;

// Re-export all functions from the API
export const {
  // API base URL configuration
  buildApiUrl,
  
  // Basic operations
  fetchAllMappings,
  fetchFieldMappings,
  createFieldMapping,
  deleteMapping,
  
  // Choice mapping operations
  fetchChoiceMappings,
  createChoiceMapping,
  
  // Statistics operations
  fetchSyncModeStats,
  
  // Discovery operations
  discoverMappings,
  
  // Bulk update operations
  updateSyncMode,
  
  // Logs operations
  fetchSyncLogs,
  fetchEntitySyncLogs,
  fetchFieldSyncLogs,
  
  // Entity mapping operations
  fetchEntityMappings,
  createEntityMapping,
  updateEntityMapping,
  deleteEntityMapping,
  
  // Entity metadata operations
  fetchDataverseEntities,
  fetchEntityFields,
  fetchEntityLookupFields,
  autoMatchFields,
  
} = api;
